export default {
  after: 'after',
  and: 'and',
  before: 'before',
  counter: 'counter',
  counters: 'counters',
  dad: 'dad',
  equalGroups: 'equal groups',
  EvenNumbers: 'Even numbers',
  equalTo: 'equal to',
  fewer: 'fewer',
  first: 'first',
  friend: 'friend',
  greaterThan: 'greater than',
  groupX: 'Group {0}',
  'In both the 5 and 10 times-tables': 'In both the<br/>5 and 10 times-tables',
  last: 'last',
  lessThan: 'less than',
  longer: 'longer',
  more: 'more',
  mum: 'mum',
  now: 'now',
  OddNumbers: 'Odd numbers',
  ones: 'Ones',
  'Only in the 5 times-table': 'Only in the 5 times-table',
  'Only in the 10 times-table': 'Only in the 10 times-table',
  pictures: 'pictures',
  shorter: 'shorter',
  shorterThan1Metre: 'Shorter than 1 metre',
  taller: 'taller',
  tallerThan1Metre: 'Taller than 1 metre',
  'ten frames': 'ten frames',
  tens: 'Tens',
  thenStr: 'then', // Changed to thenStr to avoid conflict with JS .then() method
  unequalGroups: 'unequal groups',
  xToLowercase: '{0:string|lower}',
  directions: {
    above: 'above',
    antiClockwise: 'anticlockwise',
    backwards: 'backwards',
    below: 'below',
    clockwise: 'clockwise',
    down: 'down',
    forwards: 'forwards',
    full: 'full',
    fullTurn: 'full turn',
    half: 'half',
    halfTurn: 'half turn',
    left: 'left',
    quarter: 'quarter',
    quarterTurn: 'quarter turn',
    quarterTurnAntiClockwise: 'quarter turn anticlockwise',
    quarterTurnClockwise: 'quarter turn clockwise',
    right: 'right',
    threeQuarter: 'three-quarter',
    threeQuarterTurn: 'three-quarter turn',
    threeQuarterTurnAntiClockwise: 'three-quarter turn anticlockwise',
    threeQuarterTurnClockwise: 'three-quarter turn clockwise',
    up: 'up'
  }
};
